import { Base } from './base';

export class ParkingLotSensor extends Base{
    ParkingLotSensorID?: string;
    ParkingLotID?: number;
    SensorID?: string;
    IsOccupied?: boolean;
    Date?: Date;

    //Model properties
    ParkingID?: number;
    RegistrationNumber?: string;
    ParkingLotNo?: string;
    ParkingLotStatus?: string;
    ParkingLotStatusID?: number;
    Latitude?: number;
    Longitude?: number;
    PinMarker?: string;
}